import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/dist/js/adminlte.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ItemList from "./components/Item/ItemList";
import VendorList from "./components/Vendor/VendorList";
import UserList from "./components/User/UserList";

import RequisitionList from "./components/Requisition/RequisitionList";
import RequisitionForm from "./components/Requisition/RequisitionForm";
import ProcessRequisition from "./components/Requisition/ProcessRequisition"; 
import ViewRequisition from "./components/Requisition/ViewRequisition";
import IssueRequisition from "./components/Requisition/IssueRequisition";
import ReturnRequisitionForm from "./components/Requisition/ReturnRequisitionForm";

import PurchaseOrderForm from "./components/PurchaseOrder/PurchaseOrderForm";
import PurchaseOrderList from "./components/PurchaseOrder/PurchaseOrderList";
import PurchaseOrderView from "./components/PurchaseOrder/PurchaseOrderView";

import GRNList from "./components/GRN/GRNList";
import GRNForm from "./components/GRN/GRNForm";

import DashboardSummary from "./components/Dashboard/DashboardSummary";

import InvoiceList from "./components/Invoice/InvoiceList";
import MaintenanceList from "./components/Maintenance/MaintenanceList";
import Reports from "./components/Reports/Reports";
import UserLogList from "./components/UserLogs/UserLogList";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./utils/PrivateRoute";
import './styles/app.css';
import StockList from "./components/Stock/StockList";
import WorkOrderList from "./components/WorkOrder/WorkOrderList";
import WorkOrderForm from "./components/WorkOrder/WorkOrderForm";
import ViewWorkOrder from "./components/WorkOrder/ViewWorkOrder";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* ✅ Public Routes */}
		  <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* ✅ Private Routes (Inside Dashboard) */}
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>}>
          <Route index element={<DashboardSummary />} />
  <Route path="requisition" element={<RequisitionForm />} />
  <Route path="edit-requisition/:id" element={<RequisitionForm />} />
  <Route path="requisition-list" element={<RequisitionList />} />
  <Route path="view-requisition/:id" element={<ViewRequisition />} />
  <Route path="process-requisition/:id" element={<ProcessRequisition />} />
  <Route path="issue-requisition/:id" element={<IssueRequisition />} />
  <Route path="return-requisition/:id" element={<ReturnRequisitionForm />} />
  <Route path="items" element={<ItemList />} />
  <Route path="summary" element={<DashboardSummary />} />
  <Route path="vendors" element={<VendorList />} />
  <Route path="users" element={<UserList />} />
  <Route path="purchase-orders" element={<PurchaseOrderList />} />
  <Route path="create-purchase-order" element={<PurchaseOrderForm />} />
  <Route path="edit-purchase-order/:id" element={<PurchaseOrderForm />} />
  <Route path="create-grn/:id" element={<GRNForm />} />
  <Route path="grns" element={<GRNList />} />
  <Route path="invoices" element={<InvoiceList />} />
  <Route path="maintenance" element={<MaintenanceList />} />
  <Route path="reports" element={<Reports />} />
  <Route path="user-logs" element={<UserLogList />} />
  <Route path="view-purchase-order/:id" element={<PurchaseOrderView />} />
  <Route path="stock" element={<StockList />} />
  <Route path="work-orders" element={<WorkOrderList />} />
  <Route path="create-work-order" element={<WorkOrderForm />} />
  <Route path="edit-work-order/:id" element={<WorkOrderForm />} />
  <Route path="view-work-order/:id" element={<ViewWorkOrder />} />
</Route>


          {/* ✅ Catch-all Route for 404 Page */}
          <Route path="*" element={<p>Page Not Found</p>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
